<template>
  <div style="display:flex;justify-content:space-between;">
    <div style="color:white;line-height:20rem;width:2vw;">
      <span v-show="leftIndex>0" style="margin:auto" class="el-icon-back cursor-pointer" @click="preIndex"></span>
    </div>
    <div style="display:flex;overflow:hidden;width:70vw">
      <div class="test" :style="{transform:translateX}" v-for="(item, index) in banner" :key="index" :ref="'bannerHeight'+index" style="min-width:32vw;margin-right:6vw;">
        <div style="font-weight:bold;font-size:1.375rem;">{{$store.getters.language==languageZhTc?item.title:item.label}}</div>
        <p style="text-align: left;margin:1.5rem 0 2.5rem;line-height:1.5;font-size:18px;">
          {{ item.title=='冒險模式'?$t("home.banner1"):$t("home.banner2") }}
        </p>
        <img :src="item.image" style="width: 100%; height: auto; border-radius: 30px;"/>
      </div>
    </div>
    <div style="color:white;line-height:20rem;width:2vw;">
      <span v-show="leftIndex<banner.length-2" style="margin:auto" class="el-icon-right cursor-pointer" @click="nextIndex"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    banner: {
      default: ''
    },
  },
  data () {
    return {
      translateX:'',
      leftIndex:0
    }
  },
  methods: {
    preIndex(){
      this.leftIndex-=1;
      this.translateX="translateX(-"+118.75*this.leftIndex+"%)"
    },
    nextIndex(){
      this.leftIndex+=1;
      this.translateX="translateX(-"+118.75*this.leftIndex+"%)"
    },
  }
}
</script>
<style scoped>
.test{
  transition: transform 0.5s linear 0s;
}
[class^=el-icon-]{
    background: #FCC03A;
    box-shadow: 0px 0.25rem 0 #C28C00;
    border:none;
    border-radius: 50%;
    font-size:1.625rem;
    font-weight: bold;
    padding:0.25rem;
  }
</style>